import { TermsOfService } from "landing";
import { NextPage } from "next";
import { NextSeo } from "next-seo";

const TermsPage: NextPage = () => {
	return (
		<>
			<NextSeo
				title="Mango GIS - Terms of Service"
				description="Legal information about our Terms of Service"
			/>
			<TermsOfService />
		</>
	);
};

export default TermsPage;
